import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import styles from "./FilterModalCloseButton.module.scss";
import { ReactSVG } from "react-svg";

type CloseButtonProps = {
  handleClick: () => void;
  className?: string;
};

export const FilterModalCloseButton = ({
  handleClick,
  className,
}: CloseButtonProps) => {
  const { getLabel, getIcon } = useGlobalContext();

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`modal-close-btn ${styles["modal-close-btn"]} ${className}`}
      aria-label={getLabel("modal_close")}
    >
      <ReactSVG src={getIcon("close")} wrapper={"svg"} width={32} height={32} />
    </button>
  );
};
